import React, { FunctionComponent } from 'react';
import { Button, Icon } from '@scuf/common';
import './AcceptOppToast.scss';
import { cssTransition } from 'react-toastify';
import { setActiveDashboardTab } from '../../slices/userProfileSlice';
import { useAppDispatch } from '../../store';
import { DASHBOARD_TABS } from '../../constants/constants';

interface IAcceptProps {
    supplierName: string | number;
}
// Transition animations of Accept Toast
export const AcceptToastTransition = cssTransition({
    collapseDuration: 300,
    enter: 'slide-top', 
    exit: 'fade-out', 
    appendPosition: true
});

export const AcceptOppToast: FunctionComponent<IAcceptProps> = (props) => { 
    const dispatch = useAppDispatch();
    return (
        <>
            <div className="fi-toast__opp-accept">
                <Icon name="badge-check" root="common" size="small" className="badge-check-align"/>
                <span>Anomaly accepted</span>
            </div>
            <div className="fi-toast__supplier">
               {props.supplierName}
            </div>
            <div className="fi-toast__description">
                As next steps, please navigate to <br />
                <Button 
                    type="link" 
                    className="fi-toast__link" 
                    onClick={() => dispatch(setActiveDashboardTab(DASHBOARD_TABS.ALL_OPPORTUNITIES))}
                >
                    All Anomalies
                </Button>
                &nbsp;tab.
            </div>
        </>
    );
};